import { getRoleId } from "Common/Components/getRoleId";
import {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useEffect,
} from "react";

// Define the type for the context value
interface AuthContextType {
  auth: Record<string, any>;
  setAuth: Dispatch<SetStateAction<Record<string, any>>>;
  userRole: any;
  setuserRole: Dispatch<SetStateAction<any>>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

const AuthProvider = ({ children }: AuthProviderProps) => {
  const [auth, setAuth] = useState<Record<string, any>>({});
  const role = getRoleId(localStorage.getItem("app_at_mahan") || "");
  const [userRole, setuserRole] = useState<any>();
  useEffect(() => {
    setuserRole(role);
  }, [userRole]);

  return (
    <AuthContext.Provider value={{ auth, setAuth, userRole, setuserRole }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
export default AuthContext;
